module.exports = __webpack_public_path__ + "img/avatar_default.fda3837f.png";